import { Dispatch } from 'redux';
import { change } from 'redux-form';
import { updateOrderAction } from '.';
import { clearPaymentMethods as clearPaymentMethodsApi } from '../../api/order';
import { CHECKOUT_FORM_NAME } from '../../constants';
import { PAYMENT_SAVE_CREDIT_CARD } from '../../containers/checkout/constants';
import { isPaidOrder } from '../../selectors/order';
import { getOrderId } from '../../selectors/order/typedOrderSelectors';
import { CheckoutState } from '../../state';

export const clearPaymentMethods =
    () =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const initialState = getState();

        // In NOS, free orders have a special payment method automatically set
        // when items are added. This payment method is never set by the frontend
        // but is removed when the fronend calls clearPaymentMethodsApi. Removing
        // that special payment method prevents the user from placing the order
        // TODO: Remove this check after EB-219010 is fixed
        if (!isPaidOrder(initialState)) {
            return;
        }

        const orderId = getOrderId(initialState);

        dispatch(change(CHECKOUT_FORM_NAME, PAYMENT_SAVE_CREDIT_CARD, false));
        const clearResponse = await clearPaymentMethodsApi(orderId);
        const updatedOrderAfterClear = clearResponse.response;
        dispatch(updateOrderAction(updatedOrderAfterClear));
    };
